<template>
  <div class="container-fluid">

    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <form action="">
        <div class="modal-card">
          <header class="modal-card-head bg-primary">
              <span class="modal-card-title" style="color: white">
                <span>FEEDBACK</span>
                <span class="pull-right drag_pointer">
                  <!-- <v-icon color="white">pan_tool</v-icon> -->
                  <!-- <v-icon color="white">drag_indicator</v-icon> -->
                  <v-icon color="white">apps</v-icon>
                </span>
              </span>
          </header>
          <section class="modal-card-body">
            <!-- <div class="row"> -->
              <div class="columns">
                <div class="column is-6">
                  <h3>
                    Comments
                  </h3>
                  <span v-for="(comment, idx) in userComments.slice(0,5)" :key="idx">
                    <label>{{comment.fullName}} -- <em>{{comment.organization}}</em></label>
                    <p class="black--text">{{comment.comment}}</p>
                    <br/>
                  </span>
                </div>
                <div class="column is-6 form">
                  <form @submit.prevent="postComment()" autocomplete="off">
                    <div class="form-group">
                      <label for="email">Full Name:</label>
                      <input type="text" v-model="fullName" class="form-control" id="fullName" required>
                    </div>
                    <div class="form-group">
                      <label for="pwd">Organization:</label>
                      <input type="text" v-model="organization" class="form-control" id="organization" required>
                    </div>
                    <div class="form-group">
                      <textarea class="form-control" v-model="comment" rows="3" placeholder="Type your comment here ..."
                        id="comment"
                        required
                      ></textarea>
                    </div>
                    <div class="form-group">
                      <label>How has your experience on this platform been</label>
                      <ul>
                        <li>It was easy to navigate and find what I needed</li>
                        <li>It took me sometime but I found what I needed</li>
                        <li>It took me a very long time to find what I needed</li>
                        <li>I couldn't find what I needed</li>
                        <li>I don't even understand the platform</li>
                      </ul>
                    </div>
                    <div class="form-group">
                      <div class="clearfix"></div>
                      <v-btn type="submit" dark color='blue' >Submit</v-btn>
                    </div>
                  </form>
                </div>
              </div>
          </section>
          <footer class="modal-card-foot">
              <button class="button is-danger pull-right" type="button" @click="isComponentModalActive = false">CLOSE</button>
              <!-- <button class="button is-success">Do something</button> -->
          </footer>
        </div>
      </form>
    </b-modal>
    <v-speed-dial
      v-model="fab"
      :top="false"
      :bottom="true"
      :right="true"
      :left="false"
      :fixed="true"
      :absolute="false"
      :direction="'top'"
      :open-on-hover="false"
      :transition="transition"
      >
      <!-- slot="activator" -->
        <v-btn
          v-model="fab"
          color="indigo darken-2"
          slot="activator"
          dark
          fab
          :ripple="false"
          @click="loadCommentModal(isComponentModalActive)"
          id="comments-button"
        >
          <!-- <v-icon>comment</v-icon> -->
          <v-icon>fas fa-comment</v-icon>
          <!-- <v-icon>close</v-icon> -->
        </v-btn>
        <!-- <v-btn
          fab
          dark
          small
          color="purple"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="indigo"
          @click="loadCommentModal(isComponentModalActive)"
        >
          <v-icon>comment</v-icon>
        </v-btn> -->
      </v-speed-dial>
  </div>
</template>
<script>
import { db } from '@/assets/js-on/firebaseConfig';
export default {
  name: 'comment',
  components: {},
  data() {
    return {
      // start floating buttons variables
      // direction: 'left',
      // hover: false,
      // top: false,
      // right: true,
      // bottom: true,
      // left: false,
      fab: false,
      fling: false,
      tabs: null,
      transition: 'slide-y-reverse-transition',
      // end
      isComponentModalActive: false,
      // user comment attribute
      fullName: '',
      organization: '',
      comment: '',
      userComments: JSON.parse(this.$ls.get('user_comments')) || [],
      internetCheckURL: 'https://jsonplaceholder.typicode.com/todos/1'
    }
  },
  methods: {
    fetchComments() {
      var userComments = this.userComments.slice(0);
      this.$firestore.userComments.get()
      .then( querySnapShot => {
        var tempComments = [];
        querySnapShot.forEach( doc => {
          // console.log(doc.id, doc.data());
          let data = {
            'id': doc.id,
            'fullName': doc.data().fullName,
            'organization': doc.data().organization,
            'comment': doc.data().comment,
            'timestamp': doc.data().timestamp,
            'deleted': doc.data().deleted
          }
          tempComments.push(data);
        })
        // sync local storage with firestore...
        userComments = this.syncFirestoreToLocalstorage(tempComments, userComments);
        // update the localstorage with the latest comments from firestore.
        this.$ls.set('user_comments', JSON.stringify(userComments));
        // sort the comments in the order they were made...
        this.userComments = userComments.slice(0).sort( (a, b) => {return b.timestamp - a.timestamp} );

      }).catch( error => {
        console.log('cannot read from firestore', error);
      })
    },
    // check if comments in firestore is not already in local storage
    syncFirestoreToLocalstorage(tempComments, userComments) {
      var hasDocument = false;
      var commentsToSync = this.userComments.slice(0);
      for (var i = 0; i<tempComments.length; i++) {
        for (var j = 0; j<userComments.length; j++) {
          if (tempComments[i].timestamp === userComments[j].timestamp) {
            // doocument from firestore exists in local storage, skip
            hasDocument = true;
            break;
          }
        }
        // document from firestore doesn't exist and document is not deleted, add
        if (!hasDocument && !tempComments[i].deleted) {
          commentsToSync.push(tempComments[i]);
        }
        // reset hasDocument.
        hasDocument = false;
      }
      return commentsToSync.slice(0);
    },
    // check if comments in localstorage is not already on firestore
    syncLocalstorageToFirestore(tempComments, userComments) {
      // tempComments are existing comments on firestore...
      var hasDocument = false;
      var commentsToSync = [];
      for (var i = 0; i<userComments.length; i++) {
        for (var j = 0; j<tempComments.length; j++) {
          if (userComments[i].timestamp === tempComments[j].timestamp) {
            // doocument from firestore exists in local storage, skip
            hasDocument = true;
            break;
          }
        }
        // document from firestore doesn't exist, add
        if (!hasDocument) {
          commentsToSync.push(userComments[i]);
        }
        // reset hasDocument.
        hasDocument = false;
      }
      return commentsToSync.slice(0);
    },
    loadCommentModal(isModalActive) {
      // load all comments from local storage...
      var userComments = JSON.parse(this.$ls.get('user_comments'));
      this.userComments = userComments.slice(0).sort( (a, b) => {return b.timestamp - a.timestamp} )

      this.axios.get(this.internetCheckURL)
      .then( result => {
        this.fetchComments(); // fetch synchronized comments...
      }).catch(error => {
        console.log('no network to connect to API', error);
      })
      this.isComponentModalActive = !isModalActive;
    },
    // post comments and feedback to localstorage
    postComment() {
      // load comment from localstorage
      var userComments = JSON.parse(this.$ls.get('user_comments'));
      if (!userComments) {
        userComments = [];
        this.$ls.set('user_comments', JSON.stringify(userComments));
      }
      var userComment = {
        fullName: this.fullName,
        organization: this.organization,
        comment: this.comment,
        timestamp: (new Date()).getTime() + parseInt(Math.random(60)),
        deleted: false
      }
      // update the userComments
      userComments.push(userComment);
      // update the local storage...
      this.$ls.set('user_comments', JSON.stringify(userComments));
      this.userComments = userComments.slice(0).sort( (a, b) => {return b.timestamp - a.timestamp} );
      // push to firestore; check if there's network connection
      this.axios.get(this.internetCheckURL).then( result => {
        // yes, there's internet... now we update firestore with
        // existing comments not sent yet due to absence of internet
        this.$firestore.userComments.get()
        .then( querySnapShot => {
          var tempComments = [];
          querySnapShot.forEach( doc => {
            // console.log(doc.id, doc.data());
            let data = {
              'id': doc.id,
              'fullName': doc.data().fullName,
              'organization': doc.data().organization,
              'comment': doc.data().comment,
              'timestamp': doc.data().timestamp,
              'deleted': doc.data().deleted
            }
            tempComments.push(data);
          })
          // get the comments in localstorage not yet in firestore...
          var commentsToSync = this.syncLocalstorageToFirestore(tempComments, userComments);
          // add new and pending comments in local storage to firestore...
          commentsToSync.map((userComment, index) => {
            this.$firestore.userComments.add(userComment)
            .then(docRef=> {
              console.log('New comment written, id: ', docRef.id);
            }).catch( error => {
              console.log('Error adding document to firestore', error);
            });
          })
        })
      }).catch( error => {
        // no there's not, do nothing
        console.log('no network to connect to API', error);
      })
      this.fullName = this.organization = this.comment = '';
    },
  },
  firestore() {
    return {
      userComments: db.collection('user_comments'),
    }
  },
  async created() {
    await this.axios.get(this.internetCheckURL)
    .then( result => {
      // get comments from firestore and save to local storage
      this.fetchComments(); // fetch synchronized comments...
    }).catch( error => {
      console.log('No internet available, cant fetch from firestore: ', error);
    })
  }
}
</script>



// WEBPACK FOOTER //
// comments.vue?e137d0b4